// import MainContent from "../MainContent";
import MainContent2 from "../MainContent2";
//import AsideContent from "../AsideContent";
import AsideContent2 from "../AsideContent2";
import GoToTop from "../GoToTop";
import NotFound from "../assets/NotFound";

// function Content() {
const PageNotFound = () => {
    return (
        <div className="content">
            <main>
                <MainContent2 resource={NotFound}/>
            </main>
            <aside>
                <AsideContent2 resource={NotFound}/>
            </aside>
            <GoToTop />
  	    </div>
    );
}

export default PageNotFound;

